import {SubDistrictStatusType} from 'constants/index';
import {StoreAreas} from 'types';
import {SubDistrict} from 'types/location';

export const locationToStoreAreas = (locations: SubDistrict[]): StoreAreas[] => {
  if (!locations?.length) {
    return [];
  }

  return locations.map((location) => ({
    s: location.nameTh,
    p: location.district?.province?.nameTh,
    d: location.district?.nameTh,
    z: location.zipCode,
    se: location.nameEn,
    de: location.district?.nameEn,
    pe: location.district?.province?.nameEn,
    status: SubDistrictStatusType.DELIVERABLE,
    pID: location.district?.province?.id,
    dID: location.district?.id,
    sID: location.code,
    dGN: location.district?.googleName,
    sGN: location.googleName,
    pGN: location.district?.province?.googleName
  })) as StoreAreas[];
};

export const getCurrentLocation = async () => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};
